import { LogLevel } from '@azure/msal-browser';
import Env from './Env';
import { PublicClientApplication } from '@azure/msal-browser';

const b2cOptions = Env.getB2COptions();

// Msal Configurations
const config = {
  auth: {
    authority: Env.getLoginPolicyUrl(),
    clientId: b2cOptions.appId,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: '/',
    validateAuthority: false, // For Azure AD B2C keep this value false. for Azure AD it needs to validate authority. default true
    knownAuthorities: [Env.getKnownAuthority()] //e.g: caltexb2ctest01.b2clogin.com
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          // case LogLevel.Info:
          // case LogLevel.Verbose:
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            break;
        }
      }
    }
  }
};

export const authProvider = new PublicClientApplication(config);
